import { get, post } from './client'

export interface MonitorStatus {
  backend_healthy: boolean
  mysql_healthy: boolean
  redis_healthy: boolean
  redis_enabled: boolean
  requests_5m: number
  error_rate_5m: number
  slow_requests_5m: number
  last_alert_at: number
  cpu_usage_percent: number
  memory_usage_percent: number
  disk_usage_percent: number
}

export interface MonitorMetricsSummary {
  rpm: number
  tpm: number
  total_requests: number
  success_rate: number
  avg_total_ms: number
  p95_total_ms: number
  p95_upstream_ms: number
  avg_ttft_ms: number
}

export interface AlertEventItem {
  id: number
  event_type: string
  severity: string
  request_id: string
  user_id: number
  channel_id: number
  payload: string
  webhook_status: string
  created_at: number
}

export interface MonitorAlertTestPayload {
  webhook_url?: string
  secret?: string
  mention_mobiles?: string
}

export async function getMonitorStatusApi(): Promise<MonitorStatus> {
  return get<MonitorStatus>('/api/monitor/status')
}

export async function getMonitorMetricsSummaryApi(): Promise<MonitorMetricsSummary> {
  return get<MonitorMetricsSummary>('/api/monitor/metrics/summary')
}

export async function testMonitorAlertApi(payload: MonitorAlertTestPayload): Promise<{ message?: string }> {
  return post<{ message?: string }>('/api/monitor/alert/test', payload)
}

export async function listAlertEventsApi(): Promise<AlertEventItem[]> {
  return get<AlertEventItem[]>('/api/monitor/alert/events')
}
